import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { switchMap, takeUntil, takeWhile } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class PipelinePollingService {

    private readonly POLL_INTERVAL_MS = 10_000;
    private readonly MAX_DURATION_MS = 30 * 60 * 1000;

    /**
     * Lance un polling sur un fetcher tant que `isInProgress(status)` reste vrai.
     *
     * - Première requête immédiate (timer démarre à 0)
     * - Re-fetch toutes les 10 secondes
     * - Stop automatique après 30 minutes max (garde-fou en cas de pipeline bloqué)
     * - Le dernier émis (où `isInProgress` devient false) est inclus dans le flux
     *
     * @param fetcher       Fonction qui retourne l'Observable de l'entité à poller
     * @param isInProgress  Prédicat indiquant si le statut courant est intermédiaire
     * @returns Observable émettant l'entité à chaque tick et complétant quand le statut sort de in_progress
     */
    public pollUntilSettled$<T extends { processingStatus: string }>(
        fetcher: () => Observable<T>,
        isInProgress: (status: string) => boolean,
    ): Observable<T> {
        return timer(0, this.POLL_INTERVAL_MS).pipe(
            takeUntil(timer(this.MAX_DURATION_MS)),
            switchMap(() => fetcher()),
            takeWhile(entity => isInProgress(entity.processingStatus), true),
        );
    }

}
